import React from "react";
import Layout from "../components/organisms/Layout";
import Details from "../components/pages/product-detail/Details";
import Insurance from "../components/molecules/InsuranceList";
import IMG from "../assets/images/product-detail/persons/HOGAR_S2.png";
import { DetailWithImage } from "../components/pages/quote/DetailWithImage";
import Technology from "../components/pages/product-detail/Technology";

const Hogar = ({}) => {
	return (
		<Layout landingPage='person'>
			<Details type='hogar' title={"Seguro de Hogar"} />
			<DetailWithImage
				title={
					<h1>
						Tranquilidad <span className='text-primary'>en tu casa</span>
					</h1>
				}
				content='Asegura tu hogar contra incendio, inundaciones, terremoto, cristales, equipo electrónico, ROBO, responsabilidad civil con las mejores aseguradoras.'
				image={IMG}
			/>
			<Technology />
			<Insurance
				type='persons'
				current='hogar'
				title='Una amplia gama de seguros'
			/>
		</Layout>
	);
};
export default Hogar;
